
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  
  Flits(document).on("Flits:AccountPage:Visible", function(){
      Flits(".flits-account-page-container a[href$='/account/logout']").attr("data-no-instant", "");
    }); 
  
  Flits(document).on('Flits:contactUS:Loaded', function(event){  
    var data = event.detail;
    Flits.shopCountryName = 'Hong Kong'
  });
  
//   Flits(document).on('Flits:order:Loaded',function(){
//     setTimeout(function(){
//       var flits_order_status = Flits('.flits-order-card .flits-order-action-row .flits-order-status-page');
//       debugger;
//       Flits.each(flits_order_status, function(key,value) {
//         var status_url = Flits(value).attr('href');
//         var new_url = status_url.replace('/zh-tw','https://hshk-testing.myshopify.com/');       
//         Flits(value).attr('href',new_url)
//       });
//     }, 1000);
//   })

//   Flits(document).on('Flits:order:AllLoaded',function(){
//     if(window.location.href.indexOf("/zh-tw") != -1){

//       setTimeout(function(){

//         //         setInterval(function(){ 
//         var flits_order_status = Flits('.flits-order-card .flits-order-action-row .flits-order-status-page');
//         Flits.each(flits_order_status, function(key,value) {
//           debugger;
//           var status_url = Flits(value).attr('href');

//           var new_url = status_url.replace('/authenticate','')+"&locale=zh-TW"; 
//           Flits(value).attr('href',new_url)
//         });
//         //         }, 1000);
//       }, 1000);
//     }
//   });

//   Flits(document).on('click',".flits-order-status-page",function(event){
//     event.preventDefault();
//     event.stopPropagation();
//     event.stopImmediatePropagation();
//     var button = Flits(this);
//     var url = button.attr("href");
//     debugger;
//     location.href = url + "?locale=zh-TW";
   
//   });
}(Flits));
